import * as React from 'react';

import { PinnedHotelViewModel } from 'models';

import { UitkCardFeaturedHeader } from 'uitk-react-cards';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

export interface TitleHeadingProps {
  headingInfo: PinnedHotelViewModel;
}

export const TitleHeading: React.FunctionComponent<TitleHeadingProps> = ({ headingInfo }) => {
  const headingIcon = (
    <span className="all-r-margin-three">
      <UitkIcon name={headingInfo.icon} size={UitkIconSize.EXTRA_SMALL} />
    </span>
  );

  const headingText = <span className="uitk-type-300 uitk-type-medium">{headingInfo.heading}</span>;

  return (
    <UitkCardFeaturedHeader className="title__header">
      {headingInfo.icon && headingIcon}
      {headingText}
    </UitkCardFeaturedHeader>
  );
};
